import React from "react";
import { Box, Skeleton, Grid } from "@mui/material";

const ProductPageSkeleton = () => {
  return (
    <Box
      container
      sx={{
        width: "100%",
        height: "auto",
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        justifyContent: "space-between",
        gap: 2,
        mt: 15,
      }}
    >
      <Box
        display="flex"
        gap={3}
        flexDirection={{ xs: "column", sm: "row" }}
        width={{ xs: "100%", sm: "55%" }}
        justifyContent="center"
        alignItems="center"
      >
        {/* Thumbnails */}
        <Box sx={{ marginBottom: 2, ml: { xs: 0, sm: 2 } }}>
          {[1, 2, 3].map((item) => (
            <Box
              backgroundColor={"#e0e0e0"}
              borderRadius={1}
              key={item}
              variant="rectangular"
              width={100}
              height={100}
              sx={{ margin: "8px 0" }}
            />
          ))}
        </Box>
        <Box
          backgroundColor={"#e0e0e0"}
          variant="rectangular"
          width="100%"
          borderRadius={2}
          height={400}
        />
      </Box>

      <Box
        sx={{
          p: 2,
          width: { xs: "100%", sm: "40%" },
        }}
      >
        <Skeleton variant="text" width="50%" />
        <Skeleton variant="text" width="30%" />
        <Skeleton variant="text" width="70%" sx={{ marginTop: 2 }} />
        <Box display="flex" alignItems="center" sx={{ mt: 1 }}>
          <Skeleton variant="text" width="10%" />
        </Box>
        <Skeleton variant="text" width="80%" sx={{ marginTop: 2 }} />

        {/* Weight Selector */}
        <Box sx={{ mt: 2 }}>
          <Skeleton variant="text" width="20%" />
          <Skeleton
            variant="rectangular"
            width="100%"
            height={40}
            sx={{ mt: 1 }}
          />
        </Box>

        {/* Price */}
        <Skeleton variant="text" width="30%" sx={{ mt: 2 }} />

        {/* Quantity and Add to Cart */}
        <Box display="flex" alignItems="center" sx={{ mt: 2 }}>
          <Skeleton variant="rectangular" width={60} height={30} />
          <Skeleton
            variant="rectangular"
            width={60}
            height={30}
            sx={{ marginLeft: 2 }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default ProductPageSkeleton;
